module.exports = __webpack_public_path__ + "media/images/social_networks/facebook-db3405df940e6c1aaf4af34e40860be8.svg";